import { useAuthorizedMutation } from "..";
import { params } from "@/params";

export interface CreateEnrichmentRequest {
  text: string;
  type?: "classification" | "extraction";
}

export interface CreateEnrichmentResponse {
  name: string;
  task: string;
  trigger: string;
  interaction_types: string[];
  options?: Array<{
    name: string;
    value: string;
    brief?: string;
  }>;
  output_with_options?: Array<{
    name: string;
    brief?: string;
    options?: Array<{
      name: string;
      value: string;
    }>;
  }>;
  output?: Array<{
    name: string;
    brief?: string;
    options?: Array<{
      name: string;
      value: string;
    }>;
  }>;
  [key: string]: any;
}

export function useCreateEnrichment() {
  return useAuthorizedMutation<
    CreateEnrichmentResponse,
    CreateEnrichmentRequest
  >({
    url: `${params.API_URL}/platform/vercel-proxy/api/enrichment/create`,
    method: "POST",
  });
}
